import { ReactNode, useState } from 'react';

import { CourseEnrolModalInfo, CourseRegisterInterestModalInfo, ModalInfo } from 'src/types/ModalInfo';

import { defaultModalState, ModalContext } from './ModalContext';

type ModalProviderProps = {
	children: ReactNode;
};

export function ModalProvider(props: ModalProviderProps): JSX.Element {
	const [modalInfo, setModalInfo] = useState<ModalInfo | undefined>(defaultModalState.modalInfo);

	function updateModalInfo(modal: ModalInfo | undefined) {
		setModalInfo(modal);
	}

	function hideAllModals() {
		updateDisplayCourseEnrolModal(false);
		updateDisplayCourseRegisterInterestModal(false);
		updateDisplayLoginFormModal(false);
	}

	function updateDisplayCourseEnrolModal(display: boolean) {
		setModalInfo({ ...modalInfo, CourseEnrolModal: { ...modalInfo?.CourseEnrolModal, Display: display } });
	}

	function updateCourseEnrolModal(courseEnrolModalInfo: CourseEnrolModalInfo) {
		setModalInfo({ ...modalInfo, CourseEnrolModal: courseEnrolModalInfo });
	}

	function updateDisplayCourseRegisterInterestModal(display: boolean) {
		setModalInfo({
			...modalInfo,
			CourseRegisterInterestModal: { ...modalInfo?.CourseRegisterInterestModal, Display: display },
		});
	}

	function updateCourseRegisterInterestModal(courseRegisterInterestModal: CourseRegisterInterestModalInfo) {
		setModalInfo({ ...modalInfo, CourseRegisterInterestModal: courseRegisterInterestModal });
	}

	function updateDisplayLoginFormModal(display: boolean) {
		setModalInfo({ ...modalInfo, LoginFormModal: { ...modalInfo?.LoginFormModal, Display: display, Data: display ? modalInfo?.LoginFormModal?.Data : undefined, } });
	}

	return (
		<ModalContext.Provider
			value={{
				modalInfo: modalInfo,
				hideAllModals: hideAllModals,
				updateModalInfo: updateModalInfo,
				updateDisplayCourseEnrolModal: updateDisplayCourseEnrolModal,
				updateCourseEnrolModal: updateCourseEnrolModal,
				updateDisplayCourseRegisterInterestModal: updateDisplayCourseRegisterInterestModal,
				updateCourseRegisterInterestModal: updateCourseRegisterInterestModal,
				updateDisplayLoginFormModal: updateDisplayLoginFormModal,
			}}
		>
			{props.children}
		</ModalContext.Provider>
	);
}
